import { AccountStore } from '@/modules/account/accountStore';
import { ErrorStore } from '@/modules/error/errorStore';
import { NotificationStore } from '@/modules/notification/notificationStore';
import { OpinionsStore } from '@/modules/opinions/opinionsStore';
import { PageStore } from '@/modules/page/pageStore';
import { PollsStore } from '@/modules/polls/pollsStore';
import { ProfileStore } from '@/modules/profile/profileStore';
import { TasksStore } from '@/modules/tasks/tasksStore';
import { TournamentsStore } from '@/modules/tournaments/tournamentsStore';
import { UgcStore } from '@/modules/ugc/ugcStore';
import { WalletStore } from '@/modules/wallet/walletStore';

import { createContext, useContext } from 'react';

export class RootStore {
  readonly accountStore: AccountStore;
  readonly errorStore: ErrorStore;
  readonly pageStore: PageStore;
  readonly walletStore: WalletStore;
  readonly pollsStore: PollsStore;
  readonly tournamentsStore: TournamentsStore;
  readonly notificationStore: NotificationStore;
  readonly tasksStore: TasksStore;
  readonly ugcStore: UgcStore;
  readonly profileStore: ProfileStore;
  readonly opinionsStore: OpinionsStore;

  public startParams: Record<string, any> | null = null;
  public shouldSupportFullscreen: boolean = false;

  constructor({
    startParams,
    shouldSupportFullscreen,
  }: {
    startParams: Record<string, any> | null;
    shouldSupportFullscreen: boolean;
  }) {
    this.startParams = startParams;
    this.shouldSupportFullscreen = shouldSupportFullscreen;
    this.accountStore = new AccountStore({ rootStore: this });
    this.errorStore = new ErrorStore();
    this.pageStore = new PageStore();
    this.walletStore = new WalletStore({ rootStore: this });
    this.pollsStore = new PollsStore({ rootStore: this });
    this.notificationStore = new NotificationStore({ rootStore: this });
    this.tasksStore = new TasksStore({ rootStore: this });
    this.ugcStore = new UgcStore();
    this.profileStore = new ProfileStore({ rootStore: this });
    this.opinionsStore = new OpinionsStore({ rootStore: this });
    this.tournamentsStore = new TournamentsStore({ rootStore: this });
  }
}

let globalStore: RootStore | null = null;

export const ContextStore = createContext<RootStore>({} as RootStore);
export const useStore = () => useContext<RootStore>(ContextStore);

export const createStore = (params: {
  startParams: any;
  shouldSupportFullscreen: boolean;
}) => {
  if (!globalStore) {
    globalStore = new RootStore(params);
  }
  return globalStore;
};
